var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Категории водительских прав",
      "create-text": "Новая",
      "fetch-data": _vm.fetchData,
      "route-create": "DriverLicenseCategoryAdd",
      "route-edit": "DriverLicenseCategoryEdit",
      "route-view": "DriverLicenseCategoryView",
      "route-path": "/driver_license_categories",
      "can-edit": _vm.canEditDriverLicenseCategoryCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-037c6436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037c6436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategories.vue
// module id = null
// module chunks = 